import React from 'react';
import PropTypes from 'prop-types';
import { Caret } from './style';
export var CaretIcon = function CaretIcon(props) {
  return React.createElement(Caret, {
    active: props.active
  });
};
CaretIcon.propTypes = {
  active: PropTypes.bool.isRequired
};